import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { AuthContext } from '../../context/AuthContext';
import { notyf } from '../../utils/Notyf';
import '../../style/Blog.css';

const CommentSection = ({ blogId, comments: initialComments }) => {
  const { user, authToken } = useContext(AuthContext);
  const [newComment, setNewComment] = useState('');
  const [comments, setComments] = useState(initialComments);

  const handleCommentSubmit = async () => {
    if (!newComment.trim()) return;

    try {
      const response = await fetch(`https://blog-app-2-v2of.onrender.com/blogs/addComment/${blogId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          ...(authToken && { Authorization: `Bearer ${authToken}` }),
        },
        body: JSON.stringify({ comment: newComment }),
      });

      if (!response.ok) throw new Error('Failed to add comment');

      const data = await response.json();
      const addedComment = data.updatedBlog.comments.slice(-1)[0];
      setComments(prevComments => [...prevComments, addedComment]);
      setNewComment('');
      notyf.success('Comment added!');
    } catch (error) {
      // console.error('Error submitting comment:', error);
      notyf.error('Failed to add comment');
    }
  };

  const handleDeleteComment = async (commentId) => {
    try {
      const response = await fetch(`https://blog-app-2-v2of.onrender.com/blogs/deleteComment/${blogId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ commentId }),
      });

      if (!response.ok) throw new Error('Failed to delete comment');

      setComments(prevComments => prevComments.filter(comment => comment._id !== commentId));
      notyf.success('Comment deleted!');
    } catch (error) {
      // console.error('Error deleting comment:', error);
      notyf.error('Failed to delete comment');
    }
  };

  const canDelete = (comment) => {
    const commentUserId = comment.userId?._id || comment.userId;
    return user && (
      user.isAdmin ||
      String(user.id) === String(commentUserId)
    );
  };

  return (
    <div className="retro-window mt-5">
      <h3 className="fw-bold mb-4">Comments</h3>
  
      {/* Comment List */}
      <ul className="list-unstyled">
        {comments.map(comment => (
          <li
            key={comment._id}
            className="retro-post-card p-3 mb-3 d-flex flex-column"
            style={{ backgroundColor: 'white' }}
          >
            <div className="d-flex justify-content-between align-items-start">
            <p className="mb-0">
                  {comment.username ? (
                    <Link
                      to={user?.username === comment.username ? "/profile" : `/profile/${comment.username}`}
                      className="author-link"
                    >
                      {comment.username}
                    </Link>
                  ) : (
                    <span style={{ fontStyle: 'italic', color: 'gray', fontWeight: 'bold' }}>anonymous user</span>
                  )}
                </p>

  
              {canDelete(comment) && (
                <button
                  className="retro-button small-btn bg-danger text-white ms-3"
                  onClick={() => handleDeleteComment(comment._id)}
                >
                  Delete
                </button>
              )}
            </div>
  
            <div
              className="mt-3 ms-1 text-start"
              style={{
                whiteSpace: 'pre-wrap',
                color: comment.username ? 'black' : 'gray',
                fontStyle: comment.username ? 'normal' : 'italic'
              }}
            >
              {comment.comment}
            </div>
          </li>
        ))}
      </ul>
  
      {/* Comment Form */}
      <Form className="mt-4">
        <Form.Group>
          <Form.Control
            as="textarea"
            rows={2}
            value={newComment}
            onChange={e => setNewComment(e.target.value)}
            placeholder="Add your comment here"
          />
        </Form.Group>
        <button
          type="button"
          disabled={!newComment}
          onClick={handleCommentSubmit}
          className="retro-button small-btn mt-3"
        >
          Add Comment
        </button>
      </Form>
    </div>
  );  
};

export default CommentSection;
